import {
  faArrowCircleRight,
  faCheckCircle,
  faCircle,
  faTimesCircle,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo } from 'react';
import { FinancialSecurityStatusValue } from 'src/apis/contract-management/types';
import { Colors } from 'src/styles';

export const FinancialSecurityStatus = memo<{
  value: FinancialSecurityStatusValue;
}>(({ value }) => {
  switch (value) {
    case 'APPROVED':
      return (
        <span data-testid="financial-security-status">
          <FontAwesomeIcon
            icon={faCheckCircle}
            aria-hidden
            color={Colors.success}
          />{' '}
          Approved
        </span>
      );
    case 'SUBMITTED':
      return (
        <span data-testid="financial-security-status">
          <FontAwesomeIcon icon={faCircle} aria-hidden color={Colors.warning} />{' '}
          Submitted
        </span>
      );
    case 'WITHDRAWN':
      return (
        <span data-testid="financial-security-status">
          <FontAwesomeIcon
            icon={faTimesCircle}
            aria-hidden
            color={Colors.error}
          />{' '}
          Withdrawn
        </span>
      );
    case 'REJECTED':
      return (
        <span data-testid="financial-security-status">
          <FontAwesomeIcon
            icon={faTimesCircle}
            aria-hidden
            color={Colors.error}
          />{' '}
          Rejected
        </span>
      );
    case 'RELEASE_PENDING':
      return (
        <span data-testid="financial-security-status">
          <FontAwesomeIcon
            icon={faArrowCircleRight}
            aria-hidden
            color={Colors.error}
          />{' '}
          Release Pending
        </span>
      );
    case 'RELEASED':
      return (
        <span data-testid="financial-security-status">
          <FontAwesomeIcon
            icon={faTimesCircle}
            aria-hidden
            color={Colors.error}
          />{' '}
          Released
        </span>
      );
    case 'REVOKED':
      return (
        <span data-testid="financial-security-status">
          <FontAwesomeIcon
            icon={faTimesCircle}
            aria-hidden
            color={Colors.error}
          />{' '}
          Revoked
        </span>
      );
    case 'ENFORCED':
      return (
        <span data-testid="financial-security-status">
          <FontAwesomeIcon
            icon={faTimesCircle}
            aria-hidden
            color={Colors.error}
          />{' '}
          Enforced
        </span>
      );
  }
});
